import CustomTextField from './TextInputStyle'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelInput } from '../../Main'
import { InputAdornment } from '@mui/material'
import { numberFormat } from '../../../utility/Helpers'

const TextInputAdornment = (props) => {
  const {
    labelInput,
    labelStyle = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    adornmentPosition = 'start',
    adornmentText,
    onChange,
    onKeyUp,
    readOnly = false,
    allowLeadingZero = false,
    sx = {},
    sizeOption = 'default', // NEW default
    customWidth,
    customHeight,
    ...otherProps
  } = props

  // adjust based on sizeOption
  const adornmentPadding = sizeOption === 'small' ? '12px 8px' : '25px 14px'
  const adornmentFontSize = sizeOption === 'small' ? '0.75rem' : '0.875rem'
  const adornmentBorderRadius = sizeOption === 'small' ? '12px' : '25px'

  return (
    <>
      {labelInput && <LabelInput sx={{ ...labelStyle }}>{labelInput}</LabelInput>}
      <CustomTextField
        {...otherProps}
        onChange={(e) => {
          if (props.inputtype === 'number') {
            e.target.value = numberFormat(e.target.value, { leadingZeroAllowed: allowLeadingZero })
          }
          onChange(e)
        }}
        sx={{
          backgroundColor: 'white',
          borderColor: props.filled ? '#00C9A785 !important' : '#DDDDDD !important',
          width: customWidth ?? 'auto',
          height: customHeight ?? 'auto',
          ...sx,
        }}
        InputProps={{
          readOnly: readOnly,
          style: {
            paddingLeft: adornmentPosition === 'start' ? 0 : '14px',
            paddingRight: adornmentPosition === 'end' ? 0 : '14px',
          },
          startAdornment:
            adornmentPosition === 'start' ? (
              <InputAdornment
                position="start"
                sx={{
                  padding: adornmentPadding,
                  backgroundColor: props.filled ? '#00C9A785' : '#DDDDDD',
                  borderTopLeftRadius: adornmentBorderRadius,
                  borderBottomLeftRadius: adornmentBorderRadius,
                }}
              >
                <span
                  style={{
                    fontWeight: '700',
                    color: props.filled ? '#FFF' : '#7B8186',
                    fontSize: adornmentFontSize,
                  }}
                >
                  {adornmentText}
                </span>
              </InputAdornment>
            ) : null,
          endAdornment:
            adornmentPosition === 'end' ? (
              <InputAdornment
                position="end"
                sx={{
                  padding: adornmentPadding,
                  backgroundColor: props.filled ? '#00C9A785' : '#DDDDDD',
                  borderTopRightRadius: adornmentBorderRadius,
                  borderBottomRightRadius: adornmentBorderRadius,
                }}
              >
                <span
                  style={{
                    fontWeight: '700',
                    color: props.filled ? '#FFF' : '#7B8186',
                    fontSize: adornmentFontSize,
                  }}
                >
                  {adornmentText}
                </span>
              </InputAdornment>
            ) : null,
        }}
      />
    </>
  )
}

TextInputAdornment.propTypes = {
  adornmentPosition: PropTypes.string,
  adornmentText: PropTypes.string,
  allowLeadingZero: PropTypes.bool,
  filled: PropTypes.any,
  inputtype: PropTypes.string,
  labelInput: PropTypes.string,
  labelStyle: PropTypes.any,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.string,
  props: PropTypes.any,
  readOnly: PropTypes.bool,
  sx: PropTypes.any,
  sizeOption: PropTypes.oneOf(['default', 'small']), // NEW
  customWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // NEW
  customHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // NEW
}

export default TextInputAdornment
